import "@relais/design-system/styles/globals.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { registerSW } from "virtual:pwa-register";
import { configureOfflineDb } from "@relais/offline";
import { routeTree } from "./routeTree.gen";
import { initSentry } from "./lib/sentry.js";
import { OfflineProvider } from "./lib/offline-context.js";
// Effet de bord : init i18next avant tout render (offline-first, ressources
// embarquées — aucune dépendance réseau pour résoudre la langue au boot).
import "./lib/i18n.js";

// Avant tout render : capture les erreurs dès le boot.
initSentry();

// Avant tout render / tout accès à getDb() : fixe le nom de la base IndexedDB
// propre à Poseurs (isolation du stockage offline des autres apps du monorepo).
configureOfflineDb({ name: "PoseursOfflineDB" });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});
const router = createRouter({ routeTree, context: { queryClient } });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("root element missing");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <OfflineProvider>
        <RouterProvider router={router} />
      </OfflineProvider>
    </QueryClientProvider>
  </StrictMode>,
);

if ("serviceWorker" in navigator) {
  registerSW({ immediate: true });
}
